<template src="./FormStep5.html"></template>
<style lang="scss" src="./FormStep5.scss"></style>
<script>
import _ from 'lodash'

export default {
  name: 'FormStep5',

  data () {
    return {
      disableSubmit: false,
      errors: [],
      fields: [
        ['Nome', 'Cog_RagSoc', 'Email', 'Tel', 'Cell'],
        ['Forn_Attuale', 'Pod_Pdr', 'Potenza', 'Prelievo', 'Consumo', 'ResidenzaAnagrafica', 'SedeLegaleFornitura', 'IndirizzoSpedizioneBolletta', 'Top_Res', 'Via_Res', 'Civ_Res', 'Suf_Res', 'Cap_Res', 'Com_Res', 'Prov_Res', 'Nom_Recap', 'Top_Recap', 'Via_Recap', 'Civ_Recap', 'Suf_Recap', 'Cap_Recap', 'Com_Recap', 'Prov_Recap', 'Top_Forn', 'Ind_Forn', 'Civ_Forn', 'Suf_Forn', 'Cap_Forn', 'Com_Forn', 'Prov_Forn', 'Provenienza'],
        ['CF', 'PIVA', 'Tipo_Doc', 'Num_Doc', 'End_Doc', 'MetodoPagamento', 'Iban', 'TitolaritàConto', 'Nome_Iban', 'Cognome_Iban', 'CodFiscale_Iban', 'Paperless'],
        ['SchedaProdotto', 'CondizioniGeneraliFornitura', 'NotaInformativa', 'InformativaPrivacy', 'TrattamentoDati1', 'TrattamentoDati2', 'TrattamentoDati3', 'TrattamentoDati4', 'Data_Ricontatto', 'Ora_Ricontatto']
      ],
      values: {
        Data_Firma: null,
        Data_Switch: null
      }
    }
  },

  computed: {
    form() {
      return this.$store.state.form
    },

    formValues() {
      return this.$store.state.form.values
    },

    strings() {
      return this.$store.state.strings
    },

    svg() {
      return this.$store.state.svg
    },

    title() {
      return this.$store.state.title
    },

    token() {
      return this.$store.state.token
    }
  },

  mounted() {
    this.setDates()

    // remove keys
    if (['ee-dom', 'gas-dom'].includes(this.form.type)) {
      this.fields[1].splice(this.fields[1].indexOf('SedeLegaleFornitura'), 1)
    }

    if (['ee-au', 'gas-au'].includes(this.form.type)) {
      this.fields[1].splice(this.fields[1].indexOf('ResidenzaAnagrafica'), 1)
    }

    if (this.formValues.MetodoPagamento !== 'CC') {
      this.fields[2].splice(this.fields[2].indexOf('Iban'), 1)
      this.fields[2].splice(this.fields[2].indexOf('TitolaritàConto'), 1)
      this.fields[2].splice(this.fields[2].indexOf('Nome_Iban'), 1)
      this.fields[2].splice(this.fields[2].indexOf('Cognome_Iban'), 1)
      this.fields[2].splice(this.fields[2].indexOf('CodFiscale_Iban'), 1)
    }
  },

  methods: {
    displayValue(value, fieldName) {
      if (value === true || value === '1') {
        return 'sì'
      }

      if (value === false || value === '0') {
        return 'no'
      }

      if (fieldName === 'Tipo_Doc') {
        return this.strings.documenti[value]
      }

      if (fieldName === 'MetodoPagamento') {
        return this.strings.metodiPagamento[value]
      }

      return value
    },

    displayKey(fieldName) {
      if (fieldName === 'Iban') {
        if (['ee-dom', 'gas-dom'].includes(this.form.type)) {
          return this.strings.nomeIban
        } else {
          return this.strings.nomeIbanAu
        }
      }

      if (fieldName === 'Pod_Pdr') {
        if (['ee-dom', 'ee-au'].includes(this.form.type)) {
          return this.strings.pod
        } else {
          return this.strings.pdr
        }
      }

      if (fieldName.substr(0, 4) === 'Top_') {
        return this.strings.toponimo
      }

      if (fieldName.substr(0, 4) === 'Ind_') {
        return this.strings.indirizzo
      }

      if (fieldName.substr(0, 4) === 'Civ_') {
        return this.strings.numeroCivico
      }

      if (fieldName.substr(0, 4) === 'Suf_') {
        return this.strings.suffissoCivico
      }

      if (fieldName.substr(0, 4) === 'Cap_') {
        return this.strings.cap
      }

      if (fieldName.substr(0, 4) === 'Com_') {
        return this.strings.comune
      }

      if (fieldName.substr(0, 5) === 'Prov_') {
        return this.strings.provincia
      }

      return this.strings[fieldName.charAt(0).toLowerCase() + fieldName.substr(1)]
    },

    goTo (index) {
      this.$store.commit('formIndex', index)
    },

    setDates() {
      const now = new Date()
      const day = now.getDate() < 10 ? `0${now.getDate()}` : now.getDate()
      const month = (now.getMonth() + 1) < 10 ? `0${now.getMonth() + 1}` : now.getMonth() + 1

      let nextMonth = null
      let nextYear = now.getFullYear()
      if ((now.getMonth() + 2) > 12) {
        nextMonth = '01'
        nextYear = now.getFullYear() + 1
      } else if ((now.getMonth() + 2) < 10) {
        nextMonth = `0${now.getMonth() + 2}`
      } else {
        nextMonth = now.getMonth() + 2
      }

      this.values.Data_Firma = `${day}/${month}/${now.getFullYear()}`
      this.values.Data_Switch = `01/${nextMonth}/${nextYear}`
    },

    submit () {
      if (this.token) {
        this.disableSubmit = true;

        let data = {
          tokenId: this.token,
          step: 'FINAL',
          fields: [{
            field: '',
            valueField: ''
          }]
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))

        this.$apiCall('/StepFunnelWeb/AddDataStepFunnel', {
          method: 'POST',
          body: formData
        }).then(data => {
          if (data && data.status && data.status === 200) {
            // remove token
            localStorage.removeItem('agsmToken')
            localStorage.removeItem('agsmOffer')

            // redirect
            window.location.href = 'https://www.agsmaimenergia.it/it/lp/thank-you'
          } else {
            // this.errors = data.errors
            window.location.href = 'https://www.agsmaimenergia.it/it/lp/thank-you-2'
            // alert("Si sono verificati degli errori")
          }
        })

        // console.log(data)
        // console.log(JSON.stringify(data))

        // this.$apiCall('/StepFunnelWeb/AddDataSendBolletta', {
        //     method: 'POST',
        //     body: formData
        // }).then(data => {
        //     console.log(data)
        //     if (data && data.status && data.status === 200) {
        //         window.location.href = 'https://www.agsmperte.it/thank-you/'
        //     } else {
        //         alert("Si sono verificati degli errori")
        //     }
        // })
      }
    },

    validation () {
      this.errors = []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FormStep5/FormStep5.vue